<template>
	<div class="public-content" >
		<div id="errorInfo">
			<div class="code">{{code}}</div>
			<div class="descrbe">{{describ}}</div>
			<el-button class='minButton' size="small" @click="goBack">返回首页</el-button>
		</div>
	</div>
</template>

<script>
	export default{
		data (){
			return {
				code:'暂无权限',
				describ:'抱歉，该页面您暂无权限，请联系管理员在-“设置”-“成员管理”-“角色管理”中开启该功能！',
			}
		},
		methods:{
			goBack(){
				this.$router.push('/home');
			}
		}
	}
</script>

<style lang="less" scoped>
	#errorInfo{
		text-align: center;
		.code{
			font-size: 30px;
			font-weight: bold;
			margin-top: 40px;
		};
		.descrbe {
			margin-top: 10px;
		}
		.el-button{
			margin-top: 20px;
			width: 100px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/error.vue